@if (imagePath) {
  <img [src]="imagePath" [alt]="altText" />
}

<div>
  @if (lowerTitle) {
    <h3 class="lower-title">{{ lowerTitle }}</h3>
  }

  <div class="extra-content">
    <ng-content></ng-content>
  </div>
</div>